<template lang="html">
  <div class="letters-wrapper">
    <ul>
      <li class="label">开通<br />城市</li>
      <li v-for="letter in letterList" @click="here(letter)">{{ letter }}</li>
    </ul>
  </div>
</template>

<script>
export default {
  props: {
    letterList: {
      type: Array,
      default: () => []
    },
    wrapper: {
      // 最外层容器类名，不传默认 window，控制页面滚动到指定位置
      type: String,
      default: ''
    }
  },
  computed: {
    hasWrapper() {
      return this.wrapper !== ''
    }
  },
  methods: {
    here(letter) {
      let container = null
      if (this.hasWrapper) {
        container = document.querySelector(`.${this.wrapper}`)
      }
      const startScrollTop = container
        ? container.scrollTop
        : this.getScrollTop()
      const letter_target = container
        ? container.querySelector(`[data-label='${letter}']`)
        : document.querySelector(`[data-label='${letter}']`)
      if (letter_target) {
        const postionTop = letter_target.offsetTop
        this.scrollToTop(container, postionTop, startScrollTop, 300)
      }
      this.$$tracker('130201', '20000', 21107, letter)
    },
    getScrollTop() {
      let scrollTop = 0
      if (document.documentElement && document.documentElement.scrollTop) {
        scrollTop = document.documentElement.scrollTop
      } else if (document.body) {
        scrollTop = document.body.scrollTop
      }
      return scrollTop
    },
    scrollToTop(obj, scrollHeight, startPosition, duration) {
      const delta = scrollHeight - startPosition
      const startTime = Date.now()
      let timer
      const t_this = this
      function scroll() {
        clearTimeout(timer)
        const fraction = Math.min(1, (Date.now() - startTime) / duration)
        if (t_this.hasWrapper) {
          obj.scrollTop = delta * fraction + startPosition
        } else {
          window.scrollTo(0, delta * fraction + startPosition)
        }
        if (fraction < 1) {
          timer = setTimeout(scroll, 10)
        }
      }
      scroll()
    }
  }
}
</script>

<style lang="scss" scoped>
@import '../../assets/css/mixin';
.letters-wrapper {
  display: flex;
  position: fixed;
  right: 0;
  top: 0;
  bottom: 0;
  width: rem(50px);
  height: 100%;
  text-align: center;
  z-index: 5;

  ul {
    width: 100%;
    padding: rem(30px) 0;
    margin: auto;
    // background: rgba(255, 255, 255, .5);
  }
  li {
    font-size: rem(28px);
    padding: rem(8px) 0;
    &.label {
      line-height: 1.3;
      font-size: rem(18px);
    }
  }
}
</style>
